export default __webpack_public_path__ + "16770e6e5eef85cd895bb8a59e63e227.png";